"use client";

import { useEffect } from "react";
import { usePathname, useSearchParams } from "next/navigation";

declare global {
  interface Window {
    dataLayer: unknown[];
  }
}

/** Šalje virtualne page view-ove u dataLayer pri promjeni rute (SPA), da GTM može proslijediti GA4. */
export function GAListener() {
  const pathname = usePathname();
  const searchParams = useSearchParams();

  useEffect(() => {
    if (typeof window === "undefined") return;

    const pagePath = pathname + (searchParams?.toString() ? `?${searchParams.toString()}` : "");
    const pageLocation = typeof window.location !== "undefined" ? window.location.origin + pagePath : "";

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: "page_view",
      page_path: pagePath,
      page_location: pageLocation,
    });
  }, [pathname, searchParams]);

  return null;
}

